import { DbPurchases, DbPurchasesVisanet } from "./tables/DbPurchases";
import { Injectable } from "@angular/core";

import { DbCompanies, DbCustomers } from "./tables/DbCompanies";
import { DbBankAccounts, DbPaymentTypes, DbCategories, DbProfiles, DbProducts, DbRelCompanyPaymentTypes, DbLicenses, DbVendors, DbEmployees, DbRelPurchaseProducts } from "./tables/DbBankAccounts";
import { DbCallServices, DbCallInteractions } from './tables/DbCallServices';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DatabaseService {


  getCallInteractions(callServiceId: number): DbCallInteractions {

    let result = new DbCallInteractions(this.http, callServiceId);

    return result;

  }




  getCallServices(): DbCallServices {
    let result = new DbCallServices(this.http, "call_services");

    return result;
  }
  getVendors(): any {
    let result = new DbVendors(this.http);

    return result;
  }

  getEmployees(): any {
    let result = new DbEmployees(this.http);

    return result;
  }



  getLicenses(customerId: number): any {
    let result = new DbLicenses(this.http, customerId);

    return result;
  }

  public getCustomers(): DbCustomers {
    return new DbCustomers(this.http);
  }
  constructor(private http: HttpClient) {

  }
  public getPurchases(): DbPurchases {
    return new DbPurchases(this.http, `purchases`);
  }

  public getPurchasesVisanet(): DbPurchasesVisanet {
    return new DbPurchasesVisanet(this.http, `purchases_visanet`);
  }


  public getPurchasesByCustomer(customerId: number): DbPurchases {
    return new DbPurchases(this.http, `Customers/${customerId}/Purchases`);
  }

  getRelPaymentTypes(companyId: number): DbRelCompanyPaymentTypes {

    let result = new DbRelCompanyPaymentTypes(this.http, companyId);

    return result;
  }

  getRelPurchaseProducts(purchaseId: number): DbRelPurchaseProducts {

    let result = new DbRelPurchaseProducts(this.http, purchaseId);

    return result;
  }


  getCategories(): DbCategories {
    return new DbCategories(this.http);
  }
  public getCompanies(): DbCompanies {
    return new DbCompanies(this.http);
  }

  public getBankAccounts(): DbBankAccounts {
    return new DbBankAccounts(this.http);
  }

  public getPaymentTypes(): DbPaymentTypes {
    return new DbPaymentTypes(this.http);
  }

  getProfiles(): DbProfiles {
    return new DbProfiles(this.http);
  }

  getProducts(): DbProducts {
    return new DbProducts(this.http);
  }

}